import { Track } from "@/src/lib/tracking";
import { useCallback, useState } from "react";
import { OspToast } from "@ospweb/sdk-ui";

import { ROUTER_PATH } from "@config/router";
import { getPaymentCheckErrorMessage } from "@hooks/useAppPurchaseFlow";
import { usePayment } from "@hooks/usePayment";
import { sendBeginCheckoutGtm } from "@utils/member/purchaseGtm";
import { MemberProduct } from "@features/api/memberApi";

interface UseMemberStripeCheckoutParams {
  data?: MemberProduct[];
}

export const useMemberStripeCheckout = ({
  data,
}: UseMemberStripeCheckoutParams) => {
  const { handlePaymentCheck } = usePayment();
  const [isPaying, setIsPaying] = useState(false);

  const handleStripeClick = useCallback(
    async (planId: string) => {
      setIsPaying(true);
      const currentPlan = data?.find((item) => item.id === planId);
      const price = currentPlan?.price;

      const { data: paypalData, error } = await handlePaymentCheck(planId);
      Track.log("info", "Member", "[trace][pay] stripe result", {
        arg1: String(paypalData),
        arg2: String(error),
      });
      setIsPaying(false);

      if (!error) {
        // item_id 用入参 planId 而非 currentPlan.id：产品列表没命中时 currentPlan 是 undefined，
        // 但我们仍然知道用户结的是哪个套餐，不能让这条事件退化成没有商品 id。
        sendBeginCheckoutGtm({
          id: planId,
          name: currentPlan?.name,
          price,
        });
        // 跳转前清理当前 history 条目，Stripe 页点浏览器返回时会回到无参数的 /member
        window.history.replaceState({}, "", ROUTER_PATH.MEMBER);
        window.location.href = (paypalData as string) || "";
        return;
      }

      const errMsg = getPaymentCheckErrorMessage({
        code: error.code,
        msg: error.msg,
      });
      OspToast.error({
        content: errMsg,
      });
    },
    [data, handlePaymentCheck],
  );

  return {
    isPaying,
    handleStripeClick,
  };
};
